import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28, as = "div" }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Comp>
  );
};

export const SectionHeading = ({ eyebrow, title, className = "", light = false, testid }) => (
  <Reveal className={className}>
    <p className={`eyebrow ${light ? "text-champagne" : "text-wine"}`}>{eyebrow}</p>
    <h2 data-testid={testid} className={`mt-5 font-serif text-4xl font-light leading-[1.05] tracking-tight md:text-5xl lg:text-6xl ${light ? "text-ivory" : "text-wine"}`}>
      {title}
    </h2>
  </Reveal>
);
